import React, { SVGProps } from 'react'

type Props = SVGProps<SVGRectElement> & Required<Pick<SVGProps<SVGRectElement>, 'width'>>

export const SkeletonLine = ({ width, ...props }: Props) => {
  return <rect rx={2} height={8} width={width} {...props} />
}
